import { Text } from "@chakra-ui/layout";
import React, { Component } from "react";
import { connect } from "react-redux";
import Ng from "../assets/svg/nig.svg";
import Gh from "../assets/svg/icons-new/ghana.png";
import KE from "../assets/svg/kenya.svg";
import { get } from "../util/axiosLib";
import { endpoints } from "services/rateApi";
import "./css/pc.css";
import { logger } from "../util/logger";

import formatter from "../util/formatter";
class homeWallet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currency: "naira",
      nairaWallet: "",
      cedisWallet: " ",
      isLoaded: true,
      data: {},
    };
  }

  loadWallets = async () => {
    try {
      const headers = {
        authorization: `${this.props.token}`,
        "Content-Type": "application/json",
      };

      const getWalletReq = await get(
        `${process.env.REACT_APP_API_ENDPOINT}/wallets`,
        headers
      );

      const addresses = getWalletReq.data.data.addresses.data.addresses;
      const nairaWallet = addresses.filter((item) => item.coin === "ngn")[0];
      const cedisWallet = addresses.filter((item) => item.coin === "ghs")[0];
      const shilingsWallet = addresses.filter((item) => item.coin === "kes")[0];

      this.setState({
        nairaWallet,
        nairaWalletBal: Number(nairaWallet?.balance?.$numberDecimal).toFixed(3),
        cedisWallet,
        cedisWalletBal: Number(cedisWallet?.balance?.$numberDecimal).toFixed(3),
        shilingsWalletBal: Number(
          shilingsWallet?.balance?.$numberDecimal
        ).toFixed(3),
        isLoaded: true,
      });

      localStorage.setItem("nairaBal", this.state.nairaWalletBal);
      localStorage.setItem("ghBal", this.state.cedisWalletBal);
      localStorage.setItem("keBal", this.state.shilingsWalletBal);

      return Promise.resolve(true);
    } catch (err) {
      if (err?.isAxiosError) {
        logger("ERRR::: ", err);
        const errData = err.response;
        if (errData?.status === 403 || errData?.status === 401) {
          localStorage.setItem("expired", true);
        }
      } else {
        logger("Normal Error:: ", err);
      }
      return Promise.reject(err);
    }
  };

  componentDidMount() {
    this.loadWallets();

    this.props.dispatch(endpoints.getRate.initiate("btcusd"));

    const selected = document.querySelector(".pc-selected");
    const optionsContainer = document.querySelector(".pc-options-container");

    const optionsList = document.querySelectorAll(".pc-option");

    if (optionsList !== undefined) {
      // console.log(optionsList)
    }

    selected.addEventListener("click", () => {
      optionsContainer.classList.toggle("active");
      // console.log("Clicked!")
    });

    optionsList.forEach((o) => {
      o.addEventListener("click", () => {
        selected.innerHTML = o.querySelector("label").innerHTML;
        optionsContainer.classList.remove("active");
      });
    });
  }

  render() {
    const { data, status } = this.props.rate;

    const { handleChange, selectedCurrency } = this.props;

    if (status === "fulfilled") {
      localStorage.setItem("btcPrice", data.exchangeRate.buy);
    }

    return (
      <>
        <div className="hbbg-wallet h-box-m">
          <div className="hbbg-wallet-top">
            <Text
              as="label"
              fontSize="18px"
              color="rgba(255, 255, 255, 0.815)"
              d="inline-block"
            >
              Balance
            </Text>
            <div>
              <div className="pc-box">
                <div className="pc-options-container ">
                  <div className="pc-option">
                    <input
                      type="radio"
                      className="radio"
                      id="naira"
                      value="naira"
                      name="currency"
                      onChange={(e) => handleChange(e.target.value)}
                    />
                    <br />
                    <label htmlFor="naira" className="flex-opt">
                      {" "}
                      <img src={Ng} alt="" />
                      <span className="drop-span">NG</span>{" "}
                    </label>
                  </div>
                  <div className="pc-option">
                    <input
                      type="radio"
                      className="radio"
                      id="cedis"
                      value="cedis"
                      name="currency"
                      onChange={(e) => handleChange(e.target.value)}
                    />
                    <label htmlFor="cedis" className="flex-opt">
                      <img src={Gh} alt="" />
                      <span className="drop-span ">GH</span>{" "}
                    </label>
                  </div>
                  <div className="pc-option">
                    <input
                      type="radio"
                      className="radio"
                      id="shilings"
                      value="shilings"
                      name="currency"
                      onChange={(e) => handleChange(e.target.value)}
                    />
                    <label htmlFor="shilings" className="flex-opt">
                      <img src={KE} alt="" />
                      <span className="drop-span">KE</span>{" "}
                    </label>
                  </div>
                </div>

                <div className="pc-selected">
                  <img src={Ng} alt="" />
                </div>
              </div>
            </div>
          </div>
          {selectedCurrency === "naira" && (
            <Text
              as="label"
              fontSize="25px"
              mt="18px"
              d="inline-block"
              w="100%"
            >
              {this.state?.nairaWalletBal === undefined && <span>...</span>}
              {this.state?.nairaWalletBal !== undefined && (
                <span>
                  {/* {Number(this.state?.nairaWalletBal ?? 0).toLocaleString()} */}
                  {formatter("ngn").format(this.state?.nairaWalletBal ?? 0)}
                </span>
              )}
            </Text>
          )}
          {selectedCurrency === "cedis" && (
            <Text
              as="label"
              fontSize="25px"
              mt="18px"
              d="inline-block"
              w="100%"
            >
              {/* GH₵
              {" " + Number(this.state?.cedisWalletBal ?? 0).toLocaleString()} */}
              {formatter("ghs").format(this.state?.cedisWalletBal ?? 0)}
            </Text>
          )}
          {selectedCurrency === "shilings" && (
            <Text
              as="label"
              fontSize="25px"
              mt="18px"
              d="inline-block"
              w="100%"
            >
              {/* GH₵
              {" " +
                Number(this.state?.shilingsWalletBal ?? 0).toLocaleString()} */}
              {formatter("kes").format(this.state?.shilingsWalletBal ?? 0)}
            </Text>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.auth.auth.token,
  rate: endpoints.getRate.select("btcusd")(state),
});

export default connect(mapStateToProps)(homeWallet);
